import type { MessageAttachment } from '@/types/conversations'

interface LocationAttachmentProps {
  attachment: MessageAttachment
}

export function LocationAttachment({ attachment }: LocationAttachmentProps) {
  const latitude = attachment.latitude
  const longitude = attachment.longitude
  const hasCoords = typeof latitude === 'number' && typeof longitude === 'number'
  const mapsUrl = hasCoords ? `https://www.google.com/maps?q=${latitude},${longitude}` : '#'

  return (
    <a
      href={mapsUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="flex min-w-[220px] items-start gap-2 rounded-md border bg-muted/30 p-3 transition-colors hover:bg-muted/50"
    >
      <span className="text-2xl">📍</span>
      <div className="flex-1">
        {attachment.location_name ? (
          <p className="text-sm font-medium">{attachment.location_name}</p>
        ) : null}
        {attachment.location_address ? (
          <p className="text-xs text-muted-foreground">{attachment.location_address}</p>
        ) : null}
        {hasCoords ? (
          <p className="text-xs text-muted-foreground/70">
            {latitude.toFixed(5)}, {longitude.toFixed(5)}
          </p>
        ) : null}
      </div>
    </a>
  )
}
